import { Component, computed } from '@angular/core';

import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';
import { getPropsFrom } from '@lfw/roesberg.liveforms.core';

@Component({
  selector: 'lfe-horizontal-divider-form',
  templateUrl: './horizontal-divider-form.component.html',
  standalone: true,
  styleUrl: './horizontal-divider-form.component.css'
})
export class HorizontalDividerFormComponent extends BaseItemComponent<Record<string, any>> {
  properties: BaseItemProperties = {
    ...DEFAULT_BASE_PROPERTIES
  };

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `horizontal_divider_${this.currentId()}`);

  extractLocalProperties(xml: Element) {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const activationRule = props['ActivationRule'] || '';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      isGenericRepeatItem
    } as BaseItemProperties;
  }
}
